module.exports = __webpack_public_path__ + "static/media/logo.ca3ca29f.svg";